import { Button, ButtonProps } from '@sgme/ui';
import { exportCSV } from 'components/common-form/builder/form/node/field/Grid/exportCSV';
import { GridData } from 'components/common-form/builder/form/node/field/Grid/GridField.model';
import { useTranslateForm } from 'hooks/use-translate-payoff';
import { GridWithoutPaginationMetadata } from 'models/forms/fields';
import { useIntl } from 'react-intl';
import { useFormFieldData } from 'routes/essential-workspace/components/form/use-form-field-data';

type ExportGridFieldProps = Omit<ButtonProps, 'children' | 'disabled' | 'onClick' | 'purpose'> & {
  node: GridWithoutPaginationMetadata;
};
export function ExportGridField({ node, ...btnProps }: ExportGridFieldProps) {
  const { id, headers, hasRowIndexColumn, isReadOnly } = node;
  const intl = useIntl();
  const [gridData] = useFormFieldData<GridData>(id, []);

  const { translateLabel } = useTranslateForm();
  const label = translateLabel(`${id}.export`);

  const onDownload = () => exportCSV(id, headers, gridData, hasRowIndexColumn, intl);

  const canDownload = headers?.length > 0;

  if (!canDownload) {
    return null;
  }

  return (
    <Button
      iconPosition="end"
      onClick={onDownload}
      disabled={isReadOnly}
      purpose="flat"
      color="secondary"
      {...btnProps}
    >
      {label}
      <span className="icon">save_alt</span>
    </Button>
  );
}
